import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import {   isTokenExpired } from "../../utils/helpers";
import Sidebar from "../Sidebar";
import localStorageService from "../../services/LocalStorageService";

const PrivateRoute = ({ allowedRoles = [] }) => {
  const isLoggedIn = useSelector((state) => state?.availableData?.isLoggedIn);
  const userRole = localStorageService.getItem("role") || "admin";
  const token = localStorageService.getItem("token");

  return isLoggedIn || (token && !isTokenExpired()  && allowedRoles?.includes(userRole)) ? (
    <div id="wrapper">
      <Sidebar />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/" replace={true} />
  );
};

export default React.memo(PrivateRoute);
